import { render, staticRenderFns } from "./category-create.vue?vue&type=template&id=022f03e3&"
import script from "./category-create.vue?vue&type=script&lang=ts&"
export * from "./category-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports